import React from "react";
import { connect } from "react-redux";
import {
  DateFormat,
  emailRegex,
  FieldsValidation,
  studiesIds,
  unauthorizedStudyStatus,
} from "./constants";
import Sidebar from "../components/library/Sidebar/Sidebar";
import { mapDispatchToPropsLayout, mapStateToPropsLayout } from "./layout";
import { pdf } from "@react-pdf/renderer";
import moment from "moment";

export const withUserNavbar = (WrappedComponent, props) => {
  const Wrapper = (props) => {
    const { route } = props;
    return (
      <React.Fragment>
        {props.withSidebar ? (
          <>
            <Sidebar studyId={route.study} />
            <div id="content" className="visible-inactive">
              <WrappedComponent {...props} />
            </div>
          </>
        ) : (
          <div id="content">
            <WrappedComponent {...props} />
          </div>
        )}
      </React.Fragment>
    );
  };

  return React.memo(
    connect(mapStateToPropsLayout, mapDispatchToPropsLayout)(Wrapper)
  );
};

export const getFormattedDate = (processDate) => {
  const year = processDate ? moment(processDate).year() : 1;
  if (year < 2000) {
    return <span>-</span>;
  }

  return moment(processDate).format(DateFormat.BASE_FORMAT);
};

export const smoothScrollToTop = () => {
  document.getElementById("root").scroll({
    top: 0,
    behavior: "smooth",
  });
};

export const scrollToTop = () => {
  window.scrollTo({ top: 0 });
};

export const scrollModalToTop = () => {
  const element = document.getElementsByClassName("modal")[0];

  if (element) {
    element.scrollTop = 0;
  }
};

export const debounce = (func, wait, immediate) => {
  let timeout;
  return function () {
    let context = this,
      args = arguments;
    let later = () => {
      timeout = null;
      if (!immediate) func.apply(context, args);
    };
    let callNow = immediate && !timeout;
    clearTimeout(timeout);
    timeout = setTimeout(later, wait);
    if (callNow) func.apply(context, args);
  };
};

export const isNumeric = (value) => {
  return /^-?\d+$/.test(value);
};

export const validDateString = (date) => {
  switch (date) {
    case null:
      return false;
    case "Invalid date":
      return false;
    default:
      return true;
  }
};

export const pdfDownload = async (reportComponent, reportName) => {
  try {
    const blob = await pdf(reportComponent).toBlob();

    const link = document.createElement("a");
    link.href = URL.createObjectURL(blob);
    link.setAttribute("download", `${reportName}.pdf`);
    link.click();

    return Promise.resolve("success");
  } catch (error) {
    return Promise.reject(error);
  }
};

const convertToCSV = (objArray, exportDate, participantId, protocolNumber) => {
  const array = typeof objArray !== "object" ? JSON.parse(objArray) : objArray;
  const header = `Report Date,${exportDate},,,\r\nProtocol Number,${protocolNumber?.toUpperCase()},,,\r\nParticipant ID,${participantId}\r\n\r\n`;
  let str = header;

  for (let i = 0; i < array.length; i++) {
    let line = "";
    for (let index in array[i]) {
      if (line !== "") line += ",";

      line += array[i][index];
    }

    str += line + "\r\n";
  }

  return str;
};

export const getDates = (startDate, endDate) => {
  const dateArray = [];
  let currentDate = moment(startDate);
  while (currentDate <= endDate) {
    dateArray.push(moment(currentDate).format(DateFormat.BASE_FORMAT));
    currentDate = moment(currentDate).add(1, "d");
  }
  return dateArray;
};

export const exportCSVFile = (
  headers,
  items,
  exportDate,
  participantId,
  protocolNumber,
  fileName
) => {
  if (headers) {
    items.unshift(headers);
  }

  // Convert Object to JSON
  const jsonObject = JSON.stringify(items);

  const csv = convertToCSV(
    jsonObject,
    exportDate,
    participantId,
    protocolNumber
  );

  const exportedFilenmae = `${fileName}.csv` || "export.csv";

  const blob = new Blob([csv], { type: "text/csv;charset=utf-8;" });
  if (navigator.msSaveBlob) {
    // IE 10+
    navigator.msSaveBlob(blob, exportedFilenmae);
  } else {
    const link = document.createElement("a");
    if (link.download !== undefined) {
      const url = URL.createObjectURL(blob);
      link.setAttribute("href", url);
      link.setAttribute("download", exportedFilenmae);
      link.style.visibility = "hidden";
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    }
  }

  return Promise.resolve("success");
};

export const getUnauthorizedStudyStatus = (studyId) => {
  if (studyId.toLocaleLowerCase() === studiesIds.gsdiii.toLowerCase()) {
    return unauthorizedStudyStatus.gsdiii;
  } else if (
    studyId.toLocaleLowerCase() === studiesIds.lcfaod401.toLowerCase()
  ) {
    return unauthorizedStudyStatus.lcfaod401;
  } else if (
    studyId.toLocaleLowerCase() === studiesIds.lcfaod402.toLowerCase()
  ) {
    return unauthorizedStudyStatus.lcfaod402;
  } else if (
    studyId.toLocaleLowerCase() === studiesIds.beyondxlh402.toLowerCase()
  ) {
    return unauthorizedStudyStatus.beyondxlh402;
  }

  return [];
};

/**
 * Get object property ignoring case types.
 * eg: obj.property = obj.Property = obj.PROPERTY
 * @param {*} obj
 * @param {*} prop
 * @returns object property value
 */
export const getPropertyNoCase = (obj, prop) => {
  if (obj && prop) {
    return obj[
      Object.keys(obj).find((key) => key.toLowerCase() === prop.toLowerCase())
    ];
  }
};

export const isEmailValid = (email) => {
  if (email.split(",").length > 1) {
    return false;
  } else {
    if (!emailRegex.test(String(email).toLowerCase())) {
      return false;
    }
    if (
      email.split("@")[0].length > FieldsValidation.email.localPart ||
      email.length > FieldsValidation.email.size
    ) {
      return false;
    }
  }
  return true;
};
